<template>
    <div class="back-btn cursor">
        <button @click="back" class="btn-no-style back-btn-cls">
            上一步
        </button>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            
        }
    },
    methods: {
        back () {
            this.$router.go(-1);//返回上一层
        }
    }
}
</script>

<style lang="scss">
    .back-btn {
        .back-btn-cls {
            width: 216px;
            height: 60px;   
            background: #EBF4FB;
            text-align: center;
            line-height: 60px;            
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: $main-color;
            font-weight: 500;
        }
    }
</style>